import React from 'react'

const Icon = props => {
  const styles = {
    background: 'url(' + props.bgUrl + ') no-repeat',
    backgroundSize: '30px',
    display: 'block',
    margin: '0 auto 5px',
  }

  return (
    <i className="menu-icon" style={{ ...styles, ...props.styles }}></i>
  )
}

export default Icon
